import { LISTING_MODES } from "../constants/Offering.constants";

export const isListingOnline = (listingMode: string) => {
  return listingMode === LISTING_MODES.ONLINE;
};

export const isListingOffline = (listingMode: string) => {
  return listingMode === LISTING_MODES.ONLINE;
};
